import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import MessageLogLayer from "../components/MessageLogLayer";


const MessageLogList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Message Logs" />


        {/* MessageLogLayer */}
        <MessageLogLayer />

      </MasterLayout>
    </>
  )
};

export default MessageLogList;
